module.exports = __webpack_public_path__ + "static/foto-miso-ef1762a276a1bda80e73bf508ad77a63.png";